import FiveTwoNineFaqs from 'tio-employee/components/five-two-nine/faqs';

<template><FiveTwoNineFaqs /></template>
